import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import PersonAddRounded from '@mui/icons-material/PersonAddRounded';
import TSButton from 'components/common/Button/Button';

import { ROUTES } from 'constants/RoutePaths';
import { buildRoutePath } from 'utils/utility';

import { isUserAuth, userToken } from '_actions/user_actions';
import { useGetUserDetailsQuery } from 'app/api/usersApiSlice';
import EmergencyContact from '../EmergencyContact/EmergencyContact';
import MLModal from 'components/common/Modal/Modal';

const UserProfile = () => {
  const navigate = useNavigate();

  const [isAuth, setIsAuth] = useState(false);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [editMode, setEditMode] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const userEmail = useSelector((state) => state.global?.userEmail);

  useEffect(() => {
    const checkAuth = async () => {
      const t = await userToken();
      setIsAuth(!!t);
      setToken(t);
    };
    checkAuth();
    setIsLoading(false);
  }, []);

  const { data: userData, isLoading: isUserLoading } = useGetUserDetailsQuery(
    userEmail,
    { skip: !userEmail }
  );

  const emCont = userData?.[0]?.emergency_contacts
    ? [...userData?.[0]?.emergency_contacts]
    : [];

  const toggleModal = (state) => {
    setIsModalOpen(state);
  };

  if (isLoading || isUserLoading) {
    return <div className="ts-page">Loading...</div>;
  } else {
    return (
      <>
        <div className="ts-page ts-page--wide flex flex-col gap-6">
          <header className="flex flex-col gap-1">
            <Typography variant="h2">Profile</Typography>
            {userData?.[0]?.full_name && (
              <Typography variant="body1" color="text.secondary">
                Signed in as {userData[0].full_name}
              </Typography>
            )}
          </header>

          <section className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <Typography variant="h3">
                Emergency contacts ({emCont.length})
              </Typography>
              <Typography variant="body1" color="text.secondary">
                We contact one of these people if you do not come back from a
                walk on time.
              </Typography>
            </div>
            <div className="grid gap-4 md:grid-cols-2 md:items-start">
              {emCont
                .sort((a, b) => a.ContactName.localeCompare(b.ContactName))
                .map((contact, index) => (
                  <EmergencyContact
                    key={contact.EmergencyContactID}
                    contact={contact}
                    index={index}
                  />
                ))}
            </div>
            <div>
              <TSButton
                btnText="Add a contact"
                btnVariant="outlined"
                icon={<PersonAddRounded />}
                onClickFunc={() => toggleModal(true)}
              />
            </div>
          </section>
        </div>
        <MLModal open={isModalOpen} setOpenModal={setIsModalOpen}>
          <EmergencyContact
            contact={null}
            index={99}
            isModal={true}
            toggleModal={setIsModalOpen}
          />
        </MLModal>
      </>
    );
  }
};

export default UserProfile;
